import { __decorate } from "tslib";
import { Component } from "vue-property-decorator";
import Vue from "vue";
let UIComponent = class UIComponent extends Vue {
};
UIComponent = __decorate([
    Component
], UIComponent);
export { UIComponent };
//# sourceMappingURL=UIComponent.js.map